import { render, staticRenderFns } from "./BoxBoloes.vue?vue&type=template&id=da8eba70&scoped=true"
import script from "./BoxBoloes.vue?vue&type=script&lang=js"
export * from "./BoxBoloes.vue?vue&type=script&lang=js"
import style0 from "./BoxBoloes.scss?vue&type=style&index=0&id=da8eba70&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8eba70",
  null
  
)

export default component.exports